<template>
    <div class="entity-picker">
        <div class="search-panel">
            <input maxlength="128" :placeholder="$t('chatbotv2.typeSearchValue')" type="text" v-model="query" />
            <span class="material-icons"> search </span>
        </div>
        <div class="entity-list">
            <div class="entity-select">
                <div class="text-uppercase caption" v-if="userEntities.length">{{ $t("chatbotv2.userEntities") }}</div>
                <div
                    class="picker-item"
                    v-for="entity of entitiesUser"
                    @click="pick(`user_` + entity.name)"
                    :class="{ active: defaultSelected === `user_` + entity.name }"
                    v-if="userEntities.length"
                >
                    <span class="name">{{ entity.name }} </span>
                    <span class="description"> </span>
                </div>
                <div class="text-uppercase caption">{{ $t("chatbotv2.systemEntities") }}</div>
                <div
                    class="picker-item"
                    v-for="entity of entitiesSystem"
                    @click="pick(entity.value)"
                    :class="{ active: defaultSelected === entity.value }"
                >
                    <span class="name">{{ $t(`chatbotv2.${entity.value}`) }} </span>
                    <span class="description">
                        {{ $t(`chatbotv2.${entity.value}Description`) }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EntityTypes } from "../../../palatteEnums";
import { mapState } from "vuex";

export default {
    name: "ValidationEntityPicker",
    props: {
        defaultSelected: {
            type: String,
            required: false,
        },
        pick: {
            type: Function,
            required: true,
        },
        omit: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    data() {
        return {
            EntityTypes,
            query: "",
        };
    },
    computed: {
        ...mapState({
            userEntities: (state) => state.CB.userEntities,
        }),
        entitiesUser() {
            return this.userEntities.filter((e) => e.name.toLowerCase().includes(this.query));
        },
        entitiesSystem() {
            console.log("omitssss", this.omit);
            return Object.keys(EntityTypes)
                .filter((key) => !this.omit.includes(EntityTypes[key].value))
                .map((key) => {
                    return {
                        ...EntityTypes[key],
                        text: this.$t(`chatbotv2.${EntityTypes[key].value}`),
                    };
                })
                .filter((e) => e.text.toLowerCase().includes(this.query));
        },
    },
};
</script>

<style lang="scss">
.entity-picker {
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    max-height: 600px;
    min-height: 200px;
    user-select: none;
    width: 100%;
    padding: 5px;

    .search-panel {
        align-items: center;
        border-bottom: 1px solid #e8eef3;
        display: flex;
        flex-shrink: 0;
        position: relative;
        width: 100%;

        input {
            background: transparent;
            border: 0;
            font-size: 16px;
            height: 40px;
            line-height: 20px;
            padding-left: 45px;
            padding-right: 15px;
            width: 100%;
        }

        span {
            color: #9ba6b3;
            font-size: 18px;
            left: 15px;
            pointer-events: none;
            position: absolute;
            -webkit-transition: color 0.3s;
            transition: color 0.3s;
        }
    }

    .entity-list {
        flex-grow: 1;
        overflow-x: hidden;
        overflow-y: auto;
        padding: 15px 0;
    }

    .entity-select {
        .caption {
            margin-bottom: 10px;
            padding: 0 15px;
            color: #9ba6b3;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }
    }

    .picker-item {
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        cursor: pointer;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: 32px;
        padding: 0 15px;
        -webkit-transition: background-color 0.2s, opacity 0.2s;
        transition: background-color 0.2s, opacity 0.2s;

        &.active {
            color: #006cff !important;

            .material-icons,
            .name,
            .description {
                color: #006cff !important;
            }
        }

        &:hover {
            background-color: #f0f4f7;
        }

        .material-icons {
            color: #647283;
            font-size: 15px;
            margin-right: 11px;
        }

        .name {
            color: #22272d;
            font-size: 16px;
            font-weight: 400;
            line-height: 20px;
            margin-right: 20px;
        }

        .description {
            color: #9ba6b3;
            font-size: 15px;
            line-height: 19px;
            margin-left: auto;
            overflow: hidden !important;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
